<template>
  <div v-show="show" class="UIContentSwitcherContent">
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineProps({
  show: {
    type: Boolean,
    default: true,
  },
})
</script>

<style scoped lang="scss">
.UIContentSwitcherContent {
}
</style>
